module.exports = __webpack_public_path__ + "img/file-earmark.3777f0ed.svg";